import { render } from "./EyeIcon.vue?vue&type=template&id=f36e5d66"
const script = {}
script.render = render

export default script